import { Injectable } from '@angular/core';

export interface DataLayerEvent {
  event: string;
  identityType: string | undefined;
  userId: string | undefined;
  userProfileLoaded: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  public setTrackingConsent(consent: string) {
    const trackingConsent = localStorage.getItem('tracking_allowed');

    if (trackingConsent !== consent) {
      localStorage.setItem('tracking_allowed', consent);
      window.location.reload();
    }
  }

  public isTrackingEnabled() {
    const trackingAllowed = localStorage.getItem('tracking_allowed');
    return trackingAllowed === 'true';
  }

  public setAnalyticsConsent(consent: string) {
    const analyticsAllowed = localStorage.getItem('analytics_allowed');

    if (analyticsAllowed !== consent) {
      localStorage.setItem('analytics_allowed', consent);
    }
  }

  public isAnalyticsAllowed() {
    const analyticsAllowed = localStorage.getItem('analytics_allowed');
    return analyticsAllowed === 'true';
  }
}
